import Vue from 'vue';
import Router, { RouteRecord } from 'vue-router';
import Login from './views/login/Login.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/user/list',
    },
    {
      path: '/login',
      component: Login,
    },
    {
      path: '/user',
      children: [
        {
          name: 'Liste des utilisateurs',
          path: 'list',
          component: () => import(/* webpackChunkName: "userList" */ './views/user/UserList.vue'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'Ajouter un utilisateur',
          path: 'add',
          component: () => import(/* webpackChunkName: "userAdd" */ './views/user/UserAdd.vue'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'Edition d\'un utilistaeur',
          path: ':id/edit',
          component: () => import(/* webpackChunkName: "userEdit" */ './views/user/UserEdit.vue'),
          meta: {
            requiresAuth: true,
          },
        },
      ],
      component: () => import(/* webpackChunkName: "userOverview" */ './views/user/UserOverview.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/job',
      children: [
        {
          name: 'Liste des offres',
          path: 'list',
          component: () => import(/* webpackChunkName: "jobList" */ './views/job/JobList.vue'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'Ajouter une offre',
          path: 'add',
          component: () => import(/* webpackChunkName: "jobAdd" */ './views/job/JobAdd.vue'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'Détail de l\'offre',
          path: ':id',
          component: () => import(/* webpackChunkName: "jobDetail" */ './views/job/JobDetail.vue'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'Edition de l\'offre',
          path: ':id/edit',
          component: () => import(/* webpackChunkName: "jobEdit" */ './views/job/JobEdit.vue'),
          meta: {
            requiresAuth: true,
          },
        },
      ],
      component: () => import(/* webpackChunkName: "jobOverview" */ './views/job/JobOverview.vue'),
      meta: {
        requiresAuth: true,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record: RouteRecord) => record.meta.requiresAuth)) {
      if (sessionStorage.getItem('jwt') == null) {
          next({
              path: '/login',
              params: { nextUrl: to.fullPath },
          });
      } else {
          const user = JSON.parse(sessionStorage.getItem('user') as any);
          // TODO check if jwt token is valid
          next();
      }
  } else {
      next();
  }
});

export default router;
